import Component from "../../../lib/component";

export const BodyConfig = {
    componentTypeKey: 'Body',
    baseHtmlClass: 'nav_menu__body',
    selector: '.nav_menu__body',
};

export class Body extends Component {

    static get config() {
        return BodyConfig;
    }

    constructor(id_or_element, navMenu) {
        super({
            element: id_or_element,
            config: Body.config
        });

        this.navMenu = navMenu;

    }

    render() {
        if (this.isOpen()) this.element.classList.add('body--nav_menu_open--' + this.getSide());

        window.setTimeout(function () {
            if (!this.isOpen()) {
                this.element.classList.remove('body--nav_menu_open--' + this.getSide());
            }
        }.bind(this), 500);
    }

    isOpen() {
        return this.navMenu.isOpen();
    }

    getSide() {
        return this.navMenu.side;
    }

}